import {
  getUid,
} from './getUid';

import {
  getDatabase,
  ref,
  set,
} from 'firebase/database';

import {
  app,
} from './initializeApp';

export async function setFoods(foods)
{
  const uid = await getUid();

  return set
  (
    ref(getDatabase(app), `fatsecret/${ uid }/foods`),
    foods,
  );
}